export default function Header() {
  return (
    <header className="site-header">
      <div className="header-left">
        <p className="site-description">
          A collection of work Made by Mako.
        </p>
      </div>
    </header>
  );
}
